module.exports = __webpack_public_path__ + "img/Fond_guirlande.ccb60da.jpg";